import React, { Component } from 'react';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardStatus from './CardStatus';

import { COLORS, commonStyles } from '../styles/styles';
import clsx from 'clsx';

import mail from '../assets/closeEnvelope.svg';
import videoContent from '../assets/icon_Video_W.svg';
import journalContent from '../assets/icon_Journal_W.svg';
import pdfContent from '../assets/icon_PDF_W.svg';
import surveyContent from '../assets/icon_Survey_W.svg';
import thinktoolContent from '../assets/icon_thinktool_W.svg';
import check from '../assets/check.svg';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import iconVideo from '../assets/icon_video.svg';
import iconPdf from '../assets/icon_pdf.svg';
import iconPipe from '../assets/icon_pipe.png';
import iconInfo from '../assets/icon_info.png';
import iconComment from '../assets/icon_comment.png';

import iconCalendarX from '../assets/icon_calendarX_b.png';
import iconCalendar from '../assets/icon_calendar_b.svg';
import iconZoom from '../assets/icon_zoom_b.png';
import iconEye from '../assets/icon_eye_w.png';
import iconSurvey from '../assets/icon_assessment_b.png';
import iconThinktool from '../assets/icon_thinktool.svg';
import iconJournal from '../assets/icon_journal.svg';
import Collapse from '@material-ui/core/Collapse';
import CardContent from '@material-ui/core/CardContent';

import videoBg from '../assets/bg_video.jpg';
import pdfBg from '../assets/bg_document.jpg';
import surveyBg from '../assets/bg_survey.jpg';
import thinktoolBg from '../assets/bg_thinktool.jpg';
import journalBg from '../assets/bg_journal.jpg';
import Button from '@material-ui/core/Button';
import * as moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import CardActions from '@material-ui/core/CardActions';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IconContext } from "react-icons";


import ScaleLoader from 'react-spinners/ScaleLoader';
import { connect } from 'react-redux';
import {
  MDBBtn, 
  MDBCard, 
  MDBCardBody, 
  MDBRotatingCard,
  MDBCardImage,
  MDBCardTitle, 
  MDBCardText, 
  MDBRow, 
  MDBCol, 
  MDBIcon, 
  MDBBadge, 
  MDBContainer,
  MDBCollapseHeader,
  MDBCollapse
} from "mdbreact";
import placeHolder from '../assets/placeholder.png'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { selectedContentId } from '../redux/selectors';
import { convertTime } from '../utils';
import { toggleResubmissionPopup } from '../redux/reducers/view';
import { selectAssessment, selectAssessmentContent } from '../redux/reducers/userProgramsFull';
import { resetFetch } from '../redux/reducers/assignmentRequest';
import { MdInfo, MdDateRange } from "react-icons/md";
import { showMessageCenter } from '../redux/reducers/messagesList';
import { API_LINK, STORAGE_LINK } from '../constants';
import axios from 'axios';
const API = `${API_LINK}api`;
export const checkOverdue = dueDate => {
  // if(content.type!=='Assignments'){
   //  return true;
  // }else{
   
    return moment(dueDate).isBefore(moment().add(-1,'days'));
  //}
 
};

var att = 0


class AssessmentCard extends Component {
  state = { totalHeight:300}

  constructor(props){
    super(props)
    this.myDiv = React.createRef()
  }

  componentDidMount(){
    //let { clientHeight, clientWidth } = this.refs.myImgContainer;
    // 
    // 
    // this.setState({totalHeight:this.myDiv.current.clientHeight})
  }

  flipCard() {
   
    try {
      
      this.setState({totalHeight:this.myDiv.current.clientHeight})
      this.props.flipIt(true);
    } catch (error) {
      
    }
  }

  flipCardAgain() {
   
    try {
      
      this.setState({totalHeight:this.myDiv.current.clientHeight})
      this.props.flipIt(false);
    } catch (error) {
      
    }
  
  }
  
  render() {
    const { classes,
    isSelected,
    content,
    isTransparent,
    backgroundImg,
    type,
    name,
    due_date,
    startDate,
    moduleName,
    handleExtensionRequest,
    handleResubRequest,
    handleExpandClick,
    handleOpen,
    handleSubmit,
    handleAlert,
    description,
    contentId,
    onThinkToolClick,
    status,
    messageCount,
    handleView,
    attempts,
    isExpanded,
    showAlert,
    toggleCollapse,
    collapseID, 
    flipped1, 
    flipCard,
    handleImageLoaded,
    showDeclineMessageState,
    showDeclineMessage,
    hideDeclineMessage,
    showDeclineExtensionState,
    showDeclineExtension,
    hideDeclineExtension,
    handleViewReport,
    imageLoadedNow } = this.props;
    return (
      

     
      <div style={{position:'relative'}}>

      <MDBCard cascade className='face front z-depth-2 mb-2 assessmentCard' >
         
            <div style={{position:'relative'}}>
              <div className="compImg">
                <img src={STORAGE_LINK+backgroundImg} className="z-depth-0 rounded-corners" style={{padding: 10, width:'100%'}} alt="" onLoad={handleImageLoaded} />
              </div>
              {content.resubmission_request && content.resubmission_request.comment && <IconContext.Provider value={{ color: "white", className: "global-class-name", size:'2em' }}>
              <div style={{position:'absolute', top:15, left:15, cursor:'pointer',filter: "drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.5));"}} onClick={()=>showDeclineMessage(content.resubmission_request.comment)}>
              <MdInfo/>
              </div>
              </IconContext.Provider>}

              {content.extension_request && content.extension_request.comment && content.extension_request.comment !='Free Extension Request' && <IconContext.Provider value={{ color: "white", className: "global-class-name", size:'2em' }}>
              <div style={{position:'absolute', top:15, left:15, cursor:'pointer', filter: "drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.5));"}} onClick={()=>showDeclineExtension(content.extension_request.comment)}>
              <MdInfo/>
              </div>
              </IconContext.Provider>}
              
              <div className="compPill">
                <CardStatus className="white-text" status={status}/>
              </div>

              {(checkOverdue(due_date) && (status=='ready' || status=='not started' || status=='in progress')) ? 
                  <div style={{ position: 'absolute', bottom: 17, left: 10, padding: 5, backgroundColor: '#CCCCCC', borderRadius: '0px 5px 5px 0' }}>
                    <MdDateRange/>
                    <div style={{display:'inline-block', float:'right', marginTop:3}} className="xs-copy-popins">{convertTime(due_date)}</div>
                  </div> 
                  : 
                  <div  style={{ position: 'absolute', bottom: 17, left: 10, padding: 5, backgroundColor: '#CCCCCC', borderRadius: '0px 5px 5px 0' }}>
                    <div style={{display:'inline-block', float:'right', marginTop:3}} className="xs-copy-popins">{convertTime(due_date)}</div>
                  </div>}

                  {attempts.length>0 && <div style={{ position: 'absolute', top: 37, right: 15, color: "#ffffffd4", fontSize: "20px", textShadow: "0.07em 0 #0000008f, 0 0.07em #0000008f, -0.07em 0 #0000008f, 0 -0.07em #0000008f" }}>{attempts[attempts.length-1].percentage}%</div>}



              

              {/* <div  style={{position:'absolute', bottom:40, zIndex:2}}>
                <div className='xs-copy text-white uppercase-text text-left pt-3 pl-3'>
                  {moduleName}
                </div>
                <h6 className='text-white text-left pl-3 pb-2'>
                  {name}
                </h6>
              </div>
              <div>
                <img src={placeHolder} className="z-depth-0" style={{position:'sticky',top:0,left:0,padding: 0, width: '100%'}} alt=""/>
                <img src={STORAGE_LINK+backgroundImg} className="z-depth-0" style={{position:'absolute',top:0,left:0,padding: 0, width: '100%'}} alt="" onLoad={handleImageLoaded} />          
              </div> */}
              
            </div>
           
            <MDBCardBody style={{position:'relative'}}>
              <div className="compIcon">
                  <img src={iconSurvey} />
              </div>
              <div style={{fontSize: 12}}>
                {moduleName}
              </div>
              <h6>
                {name}
              </h6>
              {/* <div className="copy">
                {description}
              </div> */}
              
              {(checkOverdue(due_date)&& attempts.length<content.free_retakes && (status=='ready' || status=='not started' || status=='in progress' || status=='waiting' || status=='declined') ) ?
              
              <MDBBtn className="assessmentBtn w-100" size="sm"  color="warning"  onClick = {() => {handleExtensionRequest(content)}}>
                Request Extension
              </MDBBtn> : (checkOverdue(due_date) && (status=='submitted' || status=='declined' || status=='waiting') && attempts.length>=content.free_retakes ) ?
               <MDBBtn className="assessmentBtn w-100" size="sm" color="warning"  onClick = {() => {handleAlert(content)}}>
               Request Resubmission
             </MDBBtn> : checkOverdue(due_date) && (status=='ready' || status=='not started' || status=='in progress' || status=='waiting' || status=='declined') &&
             <MDBBtn className="assessmentBtn w-100" size="sm"  color="warning"  onClick = {() => {handleExtensionRequest(content)}}>
             Request Extension
           </MDBBtn>
              }
              {(!checkOverdue(due_date) && ((status=='submitted') || (status=='declined') || status=='waiting') && attempts.length>=content.free_retakes) && 
              <MDBBtn className="assessmentBtn w-100" size="sm" color="warning"  onClick = {() => {handleAlert(content)}}>
              Request Resubmission
              </MDBBtn>}
              {(content.tii_id && content.tii_id!="" && status=='ready') && 
              <MDBBtn className="assessmentBtn w-100 white-text"  size="sm" color="danger"  onClick = {() => {handleViewReport(content)}}>
                View Report
              </MDBBtn>}
              {(!checkOverdue(due_date) && (status=='not started' || status=='in progress' || status=='ready')) && 
              <MDBBtn className="assessmentBtn w-100"  size="sm" color="yellow"  onClick = {() => {handleOpen(content)}}>
                Open Attempt {attempts.length+1}
              </MDBBtn>}
              {(!checkOverdue(due_date) && (status=='ready')) && 
              <MDBBtn className="assessmentBtn w-100" size="sm" color="default"  onClick = {() => {handleSubmit(content)}}>
                Submit Attempt {attempts.length+1}
              </MDBBtn>}
              {/* {((status!='not started' || status!='in progress' || status!='ready')) && 
              <MDBBtn className="assessmentBtn w-100 btnMargin" color="green"  onClick = {() => {handleViewReport(content)}}>
               View Report
              </MDBBtn>} */}
           

              {/* <div style={{position: 'absolute', bottom: 0, width: '100%'}}>
              {attempts.length>0 && 
                <div style={{height:37, paddingTop: 5, borderTop: '1px solid #DDDDDD', textAlign: 'left'}} className='grey lighten-2 pl-2 pr-2 pb-1' onClick={()=>flipCard(true)}>
                <div className="xs-copy-ptsans" style={{width:'75%', float: 'left'}}>
                    <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round"  color="default-color text-white">{attempts.length}</MDBBadge> Past Attempts
                </div>
                <img src={iconPipe} /> 
                <div className="xs-copy-ptsans" style={{width:'25%', float: 'right', textAlign:'right'}}>
                  <MDBIcon style={{marginRight: 5, fontSize:24}} className="dark-grey-text" far icon='eye'/>
                </div>
              </div>}
            </div> */}
              <div className='grey-bar grey lighten-2 pt-1 pl-2 pr-2' style={{height:34, bottom:0}}>
                {/* <div className="xs-copy-popins" style={{width:'45%', float: 'left'}}>
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round"  color="default-color text-white">{attempts.length>1 ? att=0 :  att = 2-attempts.length}</MDBBadge> Attempts
                </div> */}
          
                <div onClick={()=>flipCard(true)}>
            
                  <div className="xs-copy-ptsans" style={{width:'65%', float: 'left'}}>
                      <MDBBadge style={{position:'static',marginRight: 8}} className="badge-lg-pill-round"  color="default-color text-dark"><img style={{width:18, marginTop:-1}} src={iconEye} /></MDBBadge>{attempts.length} Past Attempts
                  </div>
                </div>
                <img className="iconPipe" src={iconPipe} /> 
               
              </div>
              {/* <img style={{position:'absolute', right:20, bottom:26, height:25}} src={iconComment} /> */}
            </MDBCardBody>
            <ReactCSSTransitionGroup
              transitionName="fade"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
              <div style={{position:'absolute', top:"40%", width:'100%'}}>
            <ScaleLoader
             
             height={35}
             width={4}
             radius={2}
             margin='2px'
            color={COLORS.cornerstoneRed}
             loading={true}
           />
           </div>
            </div>}</ReactCSSTransitionGroup>

          </MDBCard>
        
          {}

         {flipped1 && <MDBCard style={{ position:'absolute', top:0, bottom:0, left:0, right:0, zIndex:3}}  className='face back z-depth-2'>
          <div className="compImg">
              <img src={STORAGE_LINK+backgroundImg} className="z-depth-0 " style={{padding: 10, width:'100%', borderRadius: '8px 8px 0 0'}} alt="" onLoad={handleImageLoaded} />
            </div>
            <div style={{padding: '0px !important', marginTop:-50}}>
            <div style={{height:40, paddingTop: 5, borderBottom: '1px solid #DDDDDD', backgroundColor:'#eeeeee'}} className='pl-2 pr-2 pb-1' >
              <div className="xs-copy-ptsans" style={{width:'55%', float: 'left'}}>
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round"  color="grey-color text-dark">{attempts.length}</MDBBadge> Past Attempts
              </div>
              <div onClick={()=>flipCard()} className="xs-copy-ptsans" style={{width:'35%', float: 'right', textAlign:'right', zIndex:10000}}>
                <MDBIcon style={{marginRight: 5, fontSize:18, marginTop:4}} className="dark-grey-text" icon='times'/>
              </div>
            </div>
            {attempts && attempts.map(item => (
              <div style={{backgroundColor: '#ffffff'}} key={item.attempt}>
                <div style={{height:38, paddingTop: 5, borderBottom: '1px solid #DDDDDD', position:'relative'}} className='grey lighten-2 pl-2 pr-2 pb-1' >
                  <div className="xs-copy-ptsans" style={{display: 'inlineBlock', float:'left', marginTop:3}}>
                    Attempt {item.attempt} 
                  </div>
                  <div className="xs-copy-ptsans" style={{float:'left', marginLeft:20, marginTop:3}}>{item.percentage}%</div>
                  <div onClick={()=>handleView(content, item)} className="xs-copy-ptsans" style={{display: 'inlineBlock', position: 'absolute', right: 0, right: 5, top: 10}}>
                  <MDBIcon style={{marginRight: 5, fontSize:14}} className="blue-text" icon='eye'/>
                  <img style={{float:'right', width:16, marginTop:-1}} src={iconInfo} />
                </div>
                </div>
              </div>
            ))}
            
            </div>
          
          </MDBCard>}
          {showAlert && <Dialog
            open={showAlert}
            onClose={handleAlert}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Resubmissions"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              Please note that you are requested to pay for this resubmission attempt. Please refer to your learner support consultant for the fee and process to follow. You can view the resubmission request status in the ‘resubmissions for approval’ column. Your assessment will automatically become available in the “assessments available” column, with the new submission due date, once approved. 
              Thank you and good luck
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>  {
                  handleResubRequest(content);
                  handleAlert(content);
                }
              } color="primary">
                Ok
              </Button>
              <Button onClick={handleAlert} color="primary" autoFocus>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>}
          {showDeclineMessageState && <Dialog
            open={showDeclineMessageState}
            onClose={hideDeclineMessage}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Comment"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              {content.resubmission_request.comment}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={hideDeclineMessage} color="primary" autoFocus>
                close
              </Button>
            </DialogActions>
          </Dialog>}
          {showDeclineExtensionState && <Dialog
            open={showDeclineExtensionState}
            onClose={hideDeclineExtension}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Comment"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              {content.extension_request.comment}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={hideDeclineExtension} color="primary" autoFocus>
                close
              </Button>
            </DialogActions>
          </Dialog>}
          <ReactCSSTransitionGroup
              transitionName="fade"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}>{((imageLoadedNow || this.props.contentReducer.fetchingItem==true) && contentId==this.props.currentContent) && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
              <div style={{position:'absolute', top:"40%", width:'100%'}}>
            <ScaleLoader
             
             height={35}
             width={4}
             radius={2}
             margin='2px'
             color={COLORS.cornerstoneRed}
             loading={true}
           />
           </div>
            </div>}</ReactCSSTransitionGroup>
        
        </div>
        
      
      
    );
  }
      }

AssessmentCard.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  isTransparent: PropTypes.bool,
  backgroundImg: PropTypes.string,
  type: PropTypes.string,
  messageCount: PropTypes.number,
  name: PropTypes.string,
  handleExtensionRequest: PropTypes.func,
  handleView: PropTypes.func,
  handleOpen: PropTypes.func,
  handleSubmit: PropTypes.func,
  dueDate: PropTypes.string,
  startDate: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  contentId: PropTypes.number,
  onThinkToolClick: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
  expandBar:{
    backgroundColor: '#323232',
    height:'5px'
  },
  card: {
    borderRadius: 0,
    justifyContent: 'space-between',
    height: '100%',
    minHeight:280,
    backgroundSize: 'cover',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: COLORS.white,
    opacity: 1,
  },
  isTransparent: {
    opacity: 0.4,
  },
  selectedCard: {
    borderColor: COLORS.cornerstoneRed,
  },
  cardContent: {
    padding: 0,
    flex: 1,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  defaultButton: {
    backgroundColor: COLORS.lightGrey,
    color: '#000',
    fontFamily: 'Gotham-Black',
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: 30,
    width:'100%',
    borderRadius: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: COLORS.darkGrey,
      color: '#ffffff',
    },
    '&:active': {
      boxShadow: '0 1px 12px 7px rgba(0,0,0,0.5) inset',
    },
  },
  cardContentWrapper: {
    padding: 20,
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  fileWrapper: {
    backgroundColor: '#161616',
    height:92
  },
  cardIcon:{
    position: 'absolute',
    bottom: 15,
    right: 15,
    height: 50
  },
  cardTitle: {
    fontFamily: 'Gotham-Black',
    color: COLORS.darkGrey,
    fontSize: 16,
    lineHeight: '20px',
    marginBottom: 10,
  },
  itemLeft: {
    flex: 4,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    marginTop: 28,
    '&:focus': {
      outline: 'none',
    },
  },
  assessmentDescription: {
    color: COLORS.white,
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
    textShadow: '1px 1px 3px #000'
  },
  moduleName: {
    color: COLORS.white,
    fontFamily: 'Gotham-Black',
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  doneWrapper: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  checkboxChecked: {
    display: 'block',
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: `url(${check}) 0 no-repeat`,
  },
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
  contentReducer: state.contentListReducer,
  currentContent: selectedContentId(state)
});

const mapDispatchToProps = dispatch => ({
  toggleResubmissionPopup: bool => dispatch(toggleResubmissionPopup(bool)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  selectAssessmentContent: obj => dispatch(selectAssessmentContent(obj)),
  resetFetch: () => dispatch(resetFetch())
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isShowPopup', 'togglePopup', false),
  withState('isExpanded', 'toggleExpanded', false),
  withState('showAlert', 'toggleShowAlert', false),
  withState('showDeclineMessageState', 'toggleDeclineMessage', false),
  withState('showDeclineExtensionState', 'toggleDeclineExtension', false),
  withState('flipped1', 'flipIt', false),
  withState('imageLoadedNow', 'toggleImageLoaded', true),
  withHandlers({
    onThinkToolClick: props => (event, contentId) => {
      const { openMessages, selectedContentHandler } = props;
      event.stopPropagation();
      openMessages(true);
      selectedContentHandler(contentId);
    }, 
    handleViewReport: props => async(content) => {
      const data = JSON.stringify({
        "viewer_user_id": props.loginReducer.user.userId,
        "locale": "en-GB",
        "viewer_default_permission_set": "LEARNER",
        "author_metadata_override": {
          "family_name": props.loginReducer.user.lastName,
          "given_name": props.loginReducer.user.firstName
        }
      });
      var result =  await axios({
        method: 'get',
        url: `${API}/tii_get_results`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${props.loginReducer.token}`,
        },
        params: {
          tii_data: data,
          statement_id: content.tii_id
        },
      })
      window.open(result.data.viewer_url)
    },
    
    flipCard: props => () => {
      const { isExpanded, flipped1 } = props;
      props.flipIt(!flipped1);
    },
    handleAlert: props => (item) => {
      props.selectAssessment(item.survey_id)
      props.selectAssessmentContent(item)
      props.resetFetch()
      props.toggleResubmissionPopup(true)
    },
    handleImageLoaded: props => () => {
      props.toggleImageLoaded(false)
    },
    showDeclineMessage: props => () => {
      
      props.toggleDeclineMessage(true)
    },
    hideDeclineMessage: props => () => {
      props.toggleDeclineMessage(false)
    },
    showDeclineExtension: props => () => {
      
      props.toggleDeclineExtension(true)
    },
    hideDeclineExtension: props => () => {
      props.toggleDeclineExtension(false)
    }
  }),
  lifecycle({
    
  }),
  withStyles(styles),
)(AssessmentCard);
